<script lang="ts" setup>
import { toRefs } from 'vue';

type Props = {
  id: string;
  value: boolean;
  loading: boolean;
  label: string;
  iconName: string;
  prepend?: boolean;
  hiddenLabel?: boolean;
};

const props = defineProps<Props>();
const { value, loading, label, iconName, prepend } = toRefs(props);

const emit = defineEmits<{
  (e: 'change', value: boolean): void;
}>();

const onValueChanged = (updatedValue: boolean | null) => {
  emit('change', !!updatedValue);
};
</script>

<template>
  <div class="d-flex justify-space-between align-center bg-surface-bright px-3 rounded flex-wrap">
    <div class="d-flex align-center mr-2">
      <v-icon size="small" class="mr-2">{{ iconName }}</v-icon>
      <div>{{ label }}</div>
    </div>

    <div>
      <v-switch
        :id="id"
        v-model="value"
        color="primary"
        hide-details
        inset
        :readonly="loading"
        :loading="loading"
        :aria-label="label"
        :aria-describedby="id"
        true-icon="mdi-check"
        @update:modelValue="onValueChanged"
      >
        <template v-if="prepend" #prepend>
          <v-icon :class="hiddenLabel ? 'd-none' : ''">{{ iconName }}</v-icon>
          <v-label :class="hiddenLabel ? 'd-none' : ''" :for="id">{{ label }}</v-label>
        </template>
        <template v-if="!prepend" #label>
          <v-icon :class="hiddenLabel ? 'd-none' : ''">{{ iconName }}</v-icon>
          <span class="ml-2" :class="hiddenLabel ? 'd-none' : ''">{{ label }}</span>
        </template>
      </v-switch>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
